import { Splide, SplideSlide } from '@splidejs/react-splide';

import { ArrowRight } from '@/icons';
import { IconButton } from '@/molecules';

import { toArray } from '@/lib/utils';

import type { Options } from '@splidejs/splide';
import type { FunctionComponent } from 'react';
import type { TypeSliderStepperProps } from './types';

/**
 * SliderStepper
 */
export const SliderStepper: FunctionComponent<TypeSliderStepperProps> = ({
  children,
}: TypeSliderStepperProps) => {
  const childrenArray = toArray(children);
  const options: Options = {
    type: 'slide',
    width: 1160,
    drag: true,
    arrows: true,
    pagination: true,
    gap: '0',
    autoWidth: true,
    lazyLoad: true,
    start: 0,
    flickMaxPages: 1,
    flickPower: 100,
    classes: {
      pagination: `inset-x-0 mt-4 mx-auto flex w-[150px] items-center justify-start gap-1.5 overflow-x-auto xl:hidden [&_li>button]:mb-2 [&_li>button]:h-2 [&_li>button]:w-2 [&_li>button]:scale-100 [&_li>button]:rounded-full [&_li>button]:opacity-100 [&_li>button.is-active]:bg-secondary-500 [&_li>button.is-active]:scale-100`,
    },
  };
  return (
    <>
      {/**
       * TODO: La versión que tenemos de Splide no tiene el prop Children ya que en React 17 se añadia automaticamente pero en la 18 no
       * Cuando actualicemos Splide a la última versión, podemos quitar el @ts-ignore
       * @eslint-disable-next-line @typescript-eslint/ban-ts-comment
       * @ts-expect-error types are not for react 18 */}
      <Splide
        options={options}
        className="visible relative xl:mx-auto"
        renderControls={() => (
          <div className="splide__arrows">
            <IconButton
              className="splide_arrow splide__arrow--next !absolute !right-[-84px] !top-1/2"
              size="medium"
              style="solid"
              aria-label="Slide Siguiente"
            >
              <ArrowRight color="#FFFFFF" />
            </IconButton>
            <IconButton
              className="splide_arrow splide__arrow--prev !absolute !left-[-84px] !top-1/2"
              size="medium"
              style="solid"
              aria-label="Slide Anterior"
            >
              <ArrowRight color="#FFFFFF" />
            </IconButton>
          </div>
        )}
      >
        {childrenArray.map((child, index: number) => (
          <SplideSlide key={index}>
            <child.type {...child.props} />
          </SplideSlide>
        ))}
      </Splide>
    </>
  );
};
SliderStepper.displayName = 'SliderStepper';
